import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-shrink ml-3" }
const _hoisted_2 = { class: "flex flex-shrink self-center border border-next-neu px-2 rounded box-border" }
const _hoisted_3 = { class: "flex flex-shrink self-center ml-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardDivisorioGrigio = _resolveComponent("CardDivisorioGrigio")!

  return (_openBlock(), _createBlock(_component_CardDivisorioGrigio, null, {
    top: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-shrink px-2 text-white rounded", _ctx.coloreStatoClass])
      }, _toDisplayString(_ctx.siglaStato), 3),
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.stato), 1)
    ]),
    bottom: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.siglaProgetto), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.progetto), 1)
    ]),
    _: 1
  }))
}